import { render, staticRenderFns } from "./FlowrateChart.vue?vue&type=template&id=bfff2560&scoped=true"
import script from "./FlowrateChart.vue?vue&type=script&lang=js"
export * from "./FlowrateChart.vue?vue&type=script&lang=js"
import style0 from "./FlowrateChart.vue?vue&type=style&index=0&id=bfff2560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfff2560",
  null
  
)

export default component.exports